<template>
  <div class="map">
    <div
      v-for="(item, index) in map"
      :key="index"
      @click="active(index + 1)"
      :class="activeNum == index + 1 ? 'active' : ''"
    >
      {{ item.title }}
    </div>
  </div>
</template>

<script>
export default {
  name: "MapCon",
  data() {
    return {
      map: [
        {
          title: "第五教学楼",
        },
        {
          title: "第三教学楼",
        },
        {
          title: "第二教学楼",
        },
        {
          title: "机器人实训中心",
        },
        {
          title: "旌湖尚品酒店",
        },

      ],
      activeNum: -1,
    };
  },
  mounted() {
    this.EmitEvent.$on("messaeg", (e) => {
      this.activeNum = e;
    });
  },
  methods: {
    active(num) {
      // console.log(num);

      this.activeNum = num;
      // console.log(this.$store.state.activeNum)
      document.getElementById("iframe").contentWindow.MMAPI.atlas(num);
    },
  },
};
</script>

<style scoped>
.map {
  box-sizing: border-box;
}
.map div {
  width: 100%;
  padding: 0.7vh 0;
  background: url("./../../../assets/img/list-bg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 7%;
  font-size: 0.175rem;
  font-family: "SourceHanSansCN";
  color: #deedff;
  cursor: pointer;
}
.map div:last-child {
  margin-bottom: 0;
}
.active {
  background: url("./../../../assets/img/active-list-bg.png") no-repeat !important;
  background-size: 100% 100%;
}
</style>